/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState, useCallback } from 'react'
import { IRightActionBarContext, IRightActionBarProvider } from '../../types/right-action-bar'

const rightActionBarSetting: IRightActionBarContext = {
  // Navbar visibility state
  rightActionBarVisible: true,
  setRightActionBarVisible: () => {},

  // Active drawer state
  activeDrawer: null,
  drawerContent: null,
  drawerTitle: '',
  drawerWidth: 450,

  // Drawer actions
  openDrawer: () => {},
  closeDrawer: () => {},

  // Badge management
  setBadge: () => {},
  clearBadge: () => {},
  badges: {},
}

export const RightActionBarContext = createContext(rightActionBarSetting)

// This context provider is passed to any component requiring the context
export const RightNavbarProvider = ({ children }: IRightActionBarProvider) => {
  const [rightActionBarVisible, setRightActionBarVisible] = useState(rightActionBarSetting.rightActionBarVisible)
  const [activeDrawer, setActiveDrawer] = useState<string | null>(rightActionBarSetting.activeDrawer)
  const [drawerContent, setDrawerContent] = useState<React.ReactNode>(rightActionBarSetting.drawerContent)
  const [drawerTitle, setDrawerTitle] = useState(rightActionBarSetting.drawerTitle)
  const [drawerWidth, setDrawerWidth] = useState(rightActionBarSetting.drawerWidth)
  const [badges, setBadges] = useState<Record<string, number | string>>(rightActionBarSetting.badges)

  const openDrawer = useCallback((key: string, title: string, content: React.ReactNode, width?: number) => {
    setActiveDrawer(key)
    setDrawerTitle(title)
    setDrawerContent(content)
    setDrawerWidth(width || 450)
  }, [])

  const closeDrawer = useCallback(() => {
    setActiveDrawer(null)
    setDrawerContent(null)
    setDrawerTitle('')
  }, [])

  const setBadge = useCallback((key: string, badge: number | string) => {
    setBadges(prev => ({ ...prev, [key]: badge }))
  }, [])

  const clearBadge = useCallback((key: string) => {
    setBadges(prev => {
      const newBadges = { ...prev }
      delete newBadges[key]
      return newBadges
    })
  }, [])

  const value: IRightActionBarContext = {
    rightActionBarVisible,
    setRightActionBarVisible,
    activeDrawer,
    drawerContent,
    drawerTitle,
    drawerWidth,
    openDrawer,
    closeDrawer,
    setBadge,
    clearBadge,
    badges,
  }

  return (
    <RightActionBarContext.Provider value={value}>
      {children}
    </RightActionBarContext.Provider>
  )
}
